import React from 'react';
import classNames from 'classnames';

import { CircleOcticon } from '@primer/react';

export const IconWithBorder = ({
  className,
  icon,
  padding = 2,
  size = 16,
  fill = 'white',
  bgColor = 'border-darkest',
  useTailwindStyling = false,
}) => {
  // Cannot pass IconWrapper to CircleOcticon without defining component inside render
  // eslint-disable-next-line
  const IconWrapper = WrappedIcon => ({ className: iconClassName, ...rest }) => <WrappedIcon className={classNames(iconClassName, { [`p-${padding}`]: !useTailwindStyling })} fill={fill} {...rest} />

  return (
    <CircleOcticon className={classNames(`bg-${bgColor}`, className)} size={size} icon={IconWrapper(icon)} />
  )
}

export default IconWithBorder;
